import { useEffect, useState, useRef } from "react";
import tw from "tailwind-styled-components";
import "react-toastify/dist/ReactToastify.css";
import DashboardMetrics from "../../Components/Dashboard/DashboardMetrics";
import axios from "axios";
import Config from "../../Config";
import { useSelector, useDispatch } from "react-redux";
import { useMutation } from "react-query";
import { DashboardSkeleton } from "../../Components/SkeletonLoading";
import QuickAction from "../../Components/Dashboard/QuickAction";
import Tables from "../../Components/Dashboard/Tables";
import {
  Save_Locations,
  Select_Property,
  Select_Location,
  Save_Owners,
  Save_Staffs,
  save_Brokers,
  Save_isStampRequired,
} from "../../Redux/actions";
import CollectionSummaryCard from "../../Components/Dashboard/CollectionSummaryCard";
import moment from "moment";
import DateRange from "../../Components/DateRange";
import LocationsFilterDropdown from "../../Components/LocationsFilterDropdown";
import { BoxTitle } from "../../Components/Styles/PageStyles";

const DashBoardNew = () => {
  const dispatch = useDispatch();
  const [propertyType, setPropertyType] = useState("Current Property");
  const user = useSelector((state) => state.UserReducer.user);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty,
  );

  const defaultLocations = {
    id: 0,
    name: "All Locations",
    clientId: 0,
  };
  const [apiData, setApiData] = useState();

  const [recentTransaction, setRecentTransaction] = useState();
  const [complaintSummary, setComplaintSummary] = useState();
  const [businessImpactSummary, setBusinessImpactSummary] = useState();

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD"),
  );
  const [selectedProperty, setSelectedProperty] = useState(property);
  const [selectedLocation, setSelectedLocation] = useState(defaultLocations);
  const properties = useSelector((state) => state.PropertyReducer.property);
  const locations = useSelector((state) => state.LocationsReducer.locations);

  const [appliedFilters, setAppliedFilters] = useState(() => ({
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
    propertyId: property?.id ?? 0,
    locationId: defaultLocations.id,
  }));

  useEffect(() => {
    if (!selectedLocation || !properties?.length) return;

    // If All Locations selected → force All Properties
    if (selectedLocation?.id === 0) {
      setSelectedProperty(properties[0]);
      dispatch(Select_Property(properties[0]));

      if (locations && locations.length > 0) {
        setSelectedLocation(locations[0]);
        dispatch(Select_Location(locations[0]));
      }
      return;
    }

    const isPropertyValid = properties.some(
      (p) =>
        p.id === selectedProperty?.id &&
        (p.locationId === selectedLocation.id ||
          p.location?.id === selectedLocation.id),
    );

    if (!isPropertyValid) {
      setSelectedProperty(properties[0]); // 👈 index 0
      dispatch(Select_Property(properties[0]));
    }
  }, [selectedLocation, properties]);

  const onApplyFilters = () => {
    dispatch(Select_Property(selectedProperty));
    dispatch(Select_Location(selectedLocation));
    setAppliedFilters({
      startDate,
      endDate,
      propertyId: selectedProperty?.id ?? 0,
      locationId: selectedLocation?.id ?? 0,
    });
  };

  const canApply =
    !appliedFilters ||
    appliedFilters.startDate !== startDate ||
    appliedFilters.endDate !== endDate ||
    appliedFilters.propertyId !== selectedProperty?.id ||
    appliedFilters.locationId !== selectedLocation?.id;

  const fetchFunction = async () => {
    const query = buildQuery();
    const response = await axios.get(
      `${Config.apiUrl}/user/dashboard/?${query}`,
      //`${Config.apiUrl}/user/dashboard`,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        },
      },
    );
    return response.data;
  };

  const getSuccess = (res) => {
    if (res.isSuccess === false) error = true;
    else {
      setApiData(res?.data);
      if (res?.data?.locations) {
        dispatch(Save_Locations([defaultLocations, ...res.data.locations]));
      }
      if (res?.data?.owners) {
        dispatch(Save_Owners(res.data.owners));
      }
      if (res?.data?.staffs) {
        dispatch(Save_Staffs(res.data.staffs));
      }
      if (res?.data?.brokers) {
        dispatch(save_Brokers(res.data.brokers));
      }
      setBusinessImpactSummary(res?.businessImpact);
      setComplaintSummary(res?.complaintSummary);
      if (res?.isStampPaperRequired) {
        dispatch(Save_isStampRequired(res.isStampPaperRequired));
      }
    }
  };

  const getError = (res) => {};

  const {
    isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  const buildQuery = () => {
    const params = new URLSearchParams();

    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (selectedLocation?.id) params.append("locationId", selectedLocation.id);
    if (selectedProperty?.id) params.append("propertyId", selectedProperty.id);
    return params.toString();
  };

  const submitHandler = (values) => {
    setStartDate(moment(values.startDate).format("YYYY-MM-DD"));
    setEndDate(moment(values.endDate).format("YYYY-MM-DD"));
  };

  //dispatch(Select_Property(property))

  // const handlePropertySelect = (property) => {
  //   setSelectedProperty(property);
  // };

  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
  };

  // Partner change → reset filters ONCE
  // useEffect(() => {
  //   if (!selectedPartner?.clientId) return;

  //   setAppliedFilters({
  //     startDate: moment().startOf("month").format("YYYY-MM-DD"),
  //     endDate: moment().endOf("month").format("YYYY-MM-DD"),
  //     propertyId: 0,
  //     locationId: 0,
  //   });
  // }, [selectedPartner?.clientId]);

  useEffect(() => {
    if (!appliedFilters) return;

    getListMutate();
  }, [appliedFilters, getListMutate]);

  return (
    <Container>
      <DashboardHeader title="Dashboard">
        <DateRange
          submitHandler={submitHandler}
          defaultLabel={`${moment(startDate).format("DD MMM yyyy")} - ${moment(endDate).format("DD MMM yyyy")}`}
        />

        <LocationsFilterDropdown
          locations={locations}
          selectedLocation={selectedLocation}
          onSelect={handleLocationSelect}
          placeholder="All Locations"
          className="w-full md:w-[200px]"
        />

        <ApplyButton
          disabled={!canApply}
          type="button"
          onClick={onApplyFilters}
          className="md:ml-2 self-center md:self-auto"
        >
          Apply
        </ApplyButton>
      </DashboardHeader>
      {(isLoading || isRefetching) && <DashboardSkeleton />}
      {!error && !isLoading && apiData && (
        <>
          <DashboardMetrics data={apiData?.stats} />

          <CollectionSummaryCard
            clientSummary={apiData}
            commissionStats={apiData?.commissionStats}
            followUpStats={apiData?.followUpStats}
            pipeline={apiData?.dealStats}
          />

          <div className="grid md:grid-cols-2 grid-cols-1 gap-6 mt-6 pb-12">
            <QuickAction />
            <Tables
              recentTransaction={recentTransaction}
              propertyType={propertyType}
              setPropertyType={setPropertyType}
            />
          </div>
        </>
      )}
    </Container>
  );
};

const DashboardHeader = ({ title = "Dashboard", children }) => {
  return (
    <Card>
      <Wrapper>
        {/* Left: Title */}
        <TitleWrapper>
          <BoxTitle className="!mb-0 whitespace-nowrap">{title}</BoxTitle>
        </TitleWrapper>

        {/* Right: Filters / Actions */}
        <ActionsWrapper>{children}</ActionsWrapper>
      </Wrapper>
    </Card>
  );
};

const Container = tw.div`Container`;
const ApplyButton = tw.button`
  px-5 py-2
  rounded-md
  text-sm font-medium
  transition
  shadow-md bg-gradient-to-r from-primary-color to-teal-400 

  ${({ disabled }) =>
    disabled
      ? `
        bg-gray-200
        text-gray-400
        cursor-not-allowed
      `
      : `
        bg-primary-color
        text-white
        hover:bg-primary-color/90
      `}
`;

const Card = tw.div`
  mt-2 md:mt-6
  bg-white
  rounded-lg
  shadow-sm
`;

const Wrapper = tw.div`
  flex flex-col lg:flex-row
  lg:items-center
  gap-4
  px-4 py-3
  md:px-6
`;

const TitleWrapper = tw.div`
  shrink-0
`;

const ActionsWrapper = tw.div`
  flex
  flex-col md:flex-row
  md:items-center
  gap-3
  flex-1
  justify-end
  p-2
`;

export default DashBoardNew;
